export interface InteractionStorageAdapter {
  getItem<T>(key: string, defaultValue: T): T;
  setItem<T>(key: string, value: T): void;
  removeItem(key: string): void;
}

export interface InteractionVisibilityAdapter {
  subscribe(callback: (state: 'visible' | 'hidden') => void): () => void;
}

export interface InteractionTimingAdapter {
  /** High-resolution timestamp in milliseconds */
  now(): number;
  /** Schedule callback on next frame, returns cancel ID */
  requestFrame(callback: (time?: number) => void): number;
  /** Cancel a scheduled frame */
  cancelFrame(id: number): void;
}

export interface InteractionPlatformAdapters {
  /** Session-scoped storage (cleared on tab close). Used for timer state. */
  storage: InteractionStorageAdapter;
  /** Persistent storage (survives tab close). Used for one-time flags like onboarding. */
  persistentStorage: InteractionStorageAdapter;
  visibility: InteractionVisibilityAdapter;
  timing: InteractionTimingAdapter;
}
